import { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';

import { useContext } from 'react';
import { SearchContext } from './Contexts/Context';

import { getMemberBySlug } from '../service/service';
import SakrebuloInternal from './SakrebuloInternal';

function SakrebulosTavmjdomarisMoadgileebi1() {
	const ref = useRef(null);
	const [width, setWidth] = useState(10);
	const { language } = useContext(SearchContext);
	const { id } = useParams();
	const [loading, setLoading] = useState(true);
	const [moadgile, setMoadgile] = useState([]);

	const [menu, setMenu] = useState({});
	useEffect(() => {
		const link = 'https://khulo.gov.ge/api/site_menu1.php';
		fetch(link)
			.then(response => response.json())
			.then(data => {
				setMenu(data.menu);
				Object.entries(menu).map(item => {
					if (item[1].level == 1) {
					}
				});
			});
	}, []);

	const presscenterList = Object.entries(menu).length
		? Object.entries(menu).map((item, index) => {
				if (item[1].level == 1 && item[1].name_geo == 'საკრებულო') {
					return Object.entries(menu).map((qveItem, index) => {
						if (qveItem[1].parent_id === item[1].cat_id) {
							const windoww = window.location.pathname;
							const result = windoww.split('/').pop();
							const slugg = qveItem[1].slug;
							return (
								<span key={index} className={result === slugg ? 'active' : ''}>
									<Link to={`/${qveItem[1].slug}`}>
										{language == 1 ? qveItem[1].name_geo : qveItem[1].name_eng}
									</Link>
								</span>
							);
						}
					});
				}
		  })
		: 'LOADING';

	const memberFC = async id => {
		await getMemberBySlug(id).then(data => {
			setMoadgile(data);
			setLoading(false);
		});
	};

	useEffect(() => {
		memberFC(id);
	}, [id]);

	if (loading) return <h1>LOADING</h1>;
	console.log('moadgile', moadgile);
	return (
		<motion.div
			intial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<div className='news-container margin-280px'>
				<header>
					<span className='big'>
						{' '}
						{language === 1 ? 'საკრებულო' : 'KHULO CITY ASSEMBLY'}
					</span>
					<span>საკრებულოს თავმჯდომარის მოადგილეები</span>
				</header>
				{moadgile ? (
					<SakrebuloInternal
						presscenterList={presscenterList}
						image={moadgile?.image}
						full_name={moadgile?.full_name}
						position={moadgile?.memberships[0]?.position_name}
						email={moadgile?.email}
						mobile={moadgile?.mobile}
						description={moadgile?.description}
						socials={moadgile?.socials}
						language={language}
					/>
				) : (
					<h1> LOADING</h1>
				)}
			</div>
		</motion.div>
	);
}

export default SakrebulosTavmjdomarisMoadgileebi1;
